<template>
  <div>
    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 200px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col">
            <Button 
              v-for="(obj, index) in getButtons()" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>
    <DataTable
      :key="tableKey"
      :value="users"
      :paginator="true"
      dataKey="userId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rowHover="true"
      :selection.sync="selectedUsers"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Users"
      :resizableColumns="true" 
      columnResizeMode="expand"
      @column-resize-end="colsResized"
      :reorderableColumns="false" 
      @page="onPage($event)"
      :lazy="true"
      :totalRecords="totalRecords"
      @sort="onSort($event)"
      contextMenu
      :contextMenuSelection.sync="selectedRow"
      :sortField="defaultSortField"
      :sortOrder="defaultSortOrder"
      :first="defaultFirstPage"
      :rows="defaultRows"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
    >
        <template #empty> No users found. </template>
        <template #loading> Loading users data. Please wait. </template>
        <div :key="columnsKey">
          <!-- <Column selectionMode="multiple" headerStyle="width: 3em;"></Column> -->
          <Column 
            header="Actions"
            headerStyle="width: 50px; height: 30px; padding: 10px 0px;"
            :frozen="true"
          >
            <template #body="slotProps">
              <div  
                style="height: 40px; padding: 10px 0px; display: flex; align-items: center;"
              >
                <Button 
                  icon="pi pi-ellipsis-v" 
                  class="p-button-rounded p-button-text"
                  @click="toggleActions($event, slotProps.data)"
                />
              </div>
            </template>
          </Column>
          <Column 
              v-for="(col, index) of colSelectedFieldsForTable" 
              v-if="col.fieldName !== 'Status'"
              :key="col.dbField + '_' + index"
              :field="getOptionLabel(col)[0]"
              :sortField="col.dbField.split('.').slice(-1)[0]"
              :header="col.fieldName"
              :sortable="true"
              :headerStyle="'width: ' + col.defWidth + 'px; height: 41px;'" 
          >
              <template #body="slotProps" v-if="col.fieldType !== 'Yes/No'">
                  <div
                      style="height: 40px; padding: 10px 0px;"
                  >
                      {{ getToShow(slotProps.data, col) }}
                  </div>
              </template>
              <template #body="slotProps" v-else>
                <span v-if="slotProps.data[col.dbField] == true">
                    <i class="pi pi-check" style="color: green; font-weight: bolder; font-size: 2rem;"></i>
                </span>
                <span v-else>
                </span>
              </template>
          </Column>
        <Column
          header="Status"
          :sortable="true"
          headerStyle="width: 10em;"
          sortField="status"
          filterField="status"
        >
          <template #body="slotProps">
            <span 
              :class="'ignore pointer badge ' + getStyle(slotProps.data)" 
            >
              {{ slotProps.data.status }}
            </span>
          </template>
        </Column>
        </div>
    </DataTable>
  </div>
</template>

<script>
import { formatCurrency } from '@/utils/money'
import UserService from "@/service/UserService";

import {
  columnSelectionRequest
} from '../sendRequest'

export default {
  props: [
    'users',
    'loading',
    'dbView',
    "colSelectedFieldsForTable", 
    "colSelectedFields", 
    "dbViewFields",
    'totalRecords',
    'rows',
    'currentPage',
    'reloadTable',
    'makingExport',
    'storeName'
  ],
  data: () => ({
    userService: new UserService(),
    selectedUsers: null,
    defaultSortField: '',
    defaultSortOrder: 0,
    defaultFirstPage: 1,
    defaultRows: 25,
    selectedRow: null,
    selected: [],
    previousPage: null,
    tableKey1: 0,
    columnsKey1: 0
  }),
  created() {
    this.setupComponent()
  },
  watch: {
    rows(val) {
      this.defaultRows = val
    },
    currentPage(val) {
      this.defaultFirstPage = (val - 1) * this.defaultRows
    },
    reloadTable(val) {
      
      this.setupComponent()

      this.tableKey++
    },
    users(val) {
      this.columnsKey++
    },
    selected(val) {
      
      if (val && val[0] && val[0].id) {
        this.sendingRequest = false
        columnSelectionRequest(this, 'UsersTableForLazyLoadingWithResize.vue')
      }
    },
    colSelectedFieldsForTable(val) {
      this.columnsKey++
    }
  },
  computed: {
    tableKey: {
      set(val) {
        this.tableKey1++
      }, 
      get() {
        return 'tableKey-' + this.tableKey1.toString()
      }
    },
    columnsKey: {
      set(val) {
        this.columnsKey1++
      }, 
      get() {
        return 'columnKey-' + this.columnsKey1.toString()
      }
    }
  },
  methods: {
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data && data.status && data.status.toLowerCase() === 'active') {
          return 'badge-success'
        } else if(data && data.status && data.status.toLowerCase() === 'inactive') {
          return 'badge-danger'
        }
    },
    setupComponent() {
      
      
      if (this.$store.getters[this.storeName + '/getSortField']) {
        this.defaultSortField = this.$store.getters[this.storeName + '/getSortField']
        this.defaultSortOrder = this.$store.getters[this.storeName + '/getSortOrder']
        
      } else {
        this.defaultSortField = ''
        this.defaultSortOrder = 0
      }

      this.defaultRows = this.$store.getters[this.storeName + '/getRows']
      this.defaultFirstPage = (this.$store.getters[this.storeName + '/getPage'] - 1) * this.defaultRows

    },
    onSort(event) {
      // 
      this.colSelectedFieldsForTable.forEach(element => {
        let a = element.dbField.split('.')
        if (a[a.length - 1] === event.sortField) {
          // 
          this.$emit('sortChange', {
            sortField: event.sortField,
            sortFieldId: element.id,
            sortOrder: event.sortOrder
          })
        }
      })
    },
    onPage(event) {
      
      if (!(this.previousPage && event.page === this.previousPage.page && event.rows === this.previousPage.rows && event.pageCount === this.previousPage.totalpages)) {
        this.previousPage = {
          page: event.page + 1,
          rows: event.rows,
          totalPages: event.pageCount
        }
        this.$emit('lazyNext', this.previousPage)
      }
    },
    getOptionLabel(data){
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField]
        } else {
          return data ? data.dbField.split('.').slice(-1) : []
        }
      }
    },
    getToShow(data, col) {
      let a = col.dbField.split('.')

      let b = ''
      if (a.length > 1) {
        if (data[a[0]]) {
          b = data[a[0]][a[1]]
        } else if (data[a[1]]) {
          b = data[a[1]]
        } else {
          b = ''
        }
      } else {
        b = data[col.dbField]
      }

      if (col.fieldType === "Currency" && b !== null && b !== undefined) {
        return formatCurrency(b)
      } else {
        return b
      }
    },
    colsResized(event) {
      
      
      if (
        event.element && 
        event.element.clientWidth &&
        event.element.textContent
      ) {
        let e = event.element.clientWidth
        

        if (this.colSelectedFields && this.colSelectedFields[0]) {
          
          let a = this.colSelectedFields.find(b => b.dbField.fieldName === event.element.textContent)
          

          this.setSplitButtonLocations()
          if (a && a.id) {
            this.filtersService
              .setUserViewColWidth(a.id, e)
              .then(data => {
                this.setSplitButtonLocations()

                this.$emit('colUpdated', {
                  id: a.id,
                  width: parseInt(e)
                })
              })
              .catch(error => {
                
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: `Error while updating column width.`,
                  life: 5000,
                })
              })
          }
        }
      }
    },
    runFunction(obj) {
      this.$refs.opActions.hide();
      obj.command(this)
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    getButtons(data) {
      let buttons = [
        {
          label: 'View User',
          icon: 'pi pi-eye',
          command: (that) => {
            that.viewUser(that.selectedRow)
          }
        },
        {
          label: 'Edit',
          icon: 'pi pi-pencil',
          command: async (that) => {
            let user =  await this.userService
            .getUserById(that.selectedRow.userId)
            that.$emit('edit-user',  user)
          }
        },
        {
          label: 'Login History',
          icon: 'pi pi-inbox',
          command: (that) => {
            that.viewHistory(that.selectedRow)
          }
        }
      ]

      buttons.push(
        {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: (that) => {
            that.deleteUser(that.selectedRow)
          }
        }
      )
      buttons.push(
        {
          label: 'Reset Password',
          icon: 'pi pi-ellipsis-h',
          command: (that) => {
            that.$emit('reset-password', that.selectedRow)
          }
        }
      )
        buttons.push(
        {
          label: 'Change Email',
          icon: 'pi pi-user-edit',
          command: (that) => {
            that.$emit('change-email',  that.selectedRow)
          }
        }
      )
        buttons.push(
        {
          label: 'Duplicate Widget',
          icon: 'pi pi-copy',
          command: (that) => {
            that.$emit('duplicate-widget',  that.selectedRow)
          }
        }
      )
      if (this.selectedRow && this.selectedRow.status && this.selectedRow.status === 'ACTIVE') {
        buttons.push(
          {
            label: 'Set Inactive',
            command: (that) => {
              that.$emit('set-inactive',  that.selectedRow)
            }
          }
        )
      } else if (this.selectedRow && this.selectedRow.status && this.selectedRow.status === 'INACTIVE') {
        buttons.push(
          {
            label: 'Set Active',
            command: (that) => {
              that.$emit('set-active',  that.selectedRow)
            }
          }
        )
      }
      return buttons
    },
    viewUser(user) {
      if (user && user.userId)
        this.$router.push({
          path: "users/" + user.userId + "/detail",
          params: { userid: user.userId },
        });
    },
    viewHistory(user) {
      if (user && user.userId)
        this.$router.push({
          path: "users/" + user.userId + "/history",
          params: { userid: user.userId },
        });
    },
    deleteUser(user) {
    }
  }
}
</script>

<style>

</style>

